import { spawn, call, takeLatest, put, all } from 'redux-saga/effects';

// Actions
import { validarAction } from '../../../../application/actions/validar';
import { loadersActions } from '../../../../application/actions/ui_loaders';
// import { logReqError } from '../../../ui/utils/functions';

import api from '../../../api';
const apiValidar = api(process.env.REACT_APP_URL);

export function* fetchValidar(params) {
  try {
    const { Authorization , trackId } = params.payload;
    // Cambio de estado al action loader a true
    yield put(loadersActions.changeStatusLoaderValidar({ isLoading: true }));

    //Hacemos la llamada al servicio
    const { data } = yield call(apiValidar.post,'mediopago/validar', '' , { 
        'Track-Id': trackId,
         Authorization
     });

    yield put(loadersActions.changeStatusLoaderValidar({ isLoading: false }));

    if (data) {
      yield put(validarAction.fetchValidarSuccess({ respuestaServicio: data }));
    } else {
      yield put(validarAction.fetchValidarError());

    }

  } catch {
      //Errores
    yield all([
      put(validarAction.fetchValidarError()),
      put(loadersActions.changeStatusLoaderValidar({ isLoading: false })),
    ]);
  }
}

export function* watchFetchValidar() {
  yield takeLatest(validarAction.fetchValidar.type, fetchValidar);
}

export default function* rootSaga() {
  yield spawn(watchFetchValidar);
}
